import { useEffect, useState } from "react";

type TimeInputProps = {
  name: string;
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

/**
 * Simple HH:mm (client-local) time picker. No time-picker component existed
 * anywhere in the codebase before this — built new, shared by Coach Daily
 * Monitoring's global settings block and its per-client override control
 * (see msb-docs/morning-brief/morning-brief-implementation-plan.md Stage 4).
 */
const TimeInput = ({
  name,
  value,
  defaultValue = "",
  onChange,
  disabled = false,
}: TimeInputProps) => {
  const [currentValue, setCurrentValue] = useState(value ?? defaultValue ?? "");

  useEffect(() => {
    if (value !== undefined) setCurrentValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value;
    setCurrentValue(next);
    if (onChange) onChange(next);
  };

  return (
    <input
      type="time"
      name={name}
      className="time-input"
      value={currentValue}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default TimeInput;
